import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

import { useSlackConnections } from "@/lib/zero"
import { getSlackMessageLink } from "../lib/slack-message-link"
import { useThreadContext } from "../thread-context"

// The fallback permalink needs the true first Slack message; the thread's
// capped relation only holds the newest rows, so read the oldest-rows query.
export function useThreadSlackMessageLink(): string {
	const { thread } = useThreadContext()
	const connections = useSlackConnections()
	const [oldestMessages] = useQuery(
		queries.threadOldestMessages({ threadId: thread.id }),
		{ ttl: "10m" },
	)
	const slackMessages = useMemo(
		() => oldestMessages?.slackMessages ?? thread.slackMessages ?? [],
		[oldestMessages?.slackMessages, thread.slackMessages],
	)
	// Messages carry the team they came through, so the link opens the right Slack workspace.
	const teamId = slackMessages.find((message) => message.teamId)?.teamId
	const teamUrl = (
		connections.find((row) => row.teamId === teamId) ?? connections[0]
	)?.teamUrl
	return useMemo(
		() =>
			getSlackMessageLink({
				teamUrl,
				slackChannelId: thread.slackChannelId,
				slackReplyId: thread.slackReplyId,
				slackMessages,
			}),
		[teamUrl, thread.slackChannelId, thread.slackReplyId, slackMessages],
	)
}
